<h2 mat-dialog-title>Éligibilité technique</h2>
<mat-dialog-content>
    <span>Veuillez sélectionner les opérateurs et technologies à interroger</span>
    <ng-select
        class="select my-4"
        bindLabel="displayedName"
        [items]="availableProviders"
        [(ngModel)]="selectedProviders"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="true"
        placeholder="Opérateur(s)"
        [clearable]="true"
        [popover]="true"
        notFoundText="Aucun résultat trouvé"
        >
        <ng-template ng-header-tmp>
            <div class="ng-dropdown-panel-items">

                <div
                    class="ng-option clickable"
                    [ngClass]="isAllProvidersSelected() ? 'ng-option-selected' : ''"
                    [hoverClass]="'ng-option-marked'"
                    (click)="toggleSelectAllProviders()"
                    aria-hidden="true">
                    <input 
                        type="checkbox" 
                        [checked]="isAllProvidersSelected()"
                        (change)="toggleSelectAllProviders($event)"
                    />
                    <span class="ml-1">
                        {{ isAllProvidersSelected() ? 'Tout désélectionner' : 'Tout sélectionner' }}
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ml-2">{{ item.displayedName }}</span>
        </ng-template>
    </ng-select>

    <ng-select
        class="select mb-4"
        bindLabel="displayedName"
        groupBy="type"
        [items]="availableTechnologies"
        [(ngModel)]="selectedTechnologies"
        [multiple]="true"
        [closeOnSelect]="false"
        [selectableGroup]="true"
        [selectableGroupAsModel]="false"
        [searchable]="true"
        placeholder="Technologie(s)"
        [clearable]="true"
        [popover]="true"
        notFoundText="Aucun résultat trouvé"
        >
        <ng-template ng-header-tmp>
            <div class="ng-dropdown-panel-items">

                <div 
                    class="ng-option clickable"
                    [ngClass]="isAllTechnologiesSelected() ? 'ng-option-selected' : ''" 
                    [hoverClass]="'ng-option-marked'" 
                    (click)="toggleSelectAllTechnologies()"
                    aria-hidden="true"
                    >
                    <input 
                        type="checkbox" 
                        [checked]="isAllTechnologiesSelected()"
                        (change)="toggleSelectAllTechnologies($event)"
                    />
                    <span class="ml-1">
                        {{ isAllTechnologiesSelected() ? 'Tout désélectionner' : 'Tout sélectionner' }}
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
            <input class="pr-2" id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ml-2">{{ item.type }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /><span class="ml-2">{{ item.displayedName }}</span>
        </ng-template>
    </ng-select>

    <span>Par défaut, l'éligibilité ne sera pas rejouée pour les sites sélectionnés qui en ont déjà fait l'objet. Pour la relancer, veuillez cocher l'option ci-dessous :</span>
    <br>

    <mat-checkbox [(ngModel)]="relaunchAllSites">
        Relancer l'éligibilité de tous les sites sélectionnés
    </mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false">Annuler</button>
    <button mat-stroked-button [disabled]="!canRunTechnicalEligibilty()" (click)="requestTechnicalEligibility()">
        Lancer ({{siteIds().length}}/{{data.siteIds.length}} site{{data.siteIds.length > 1 ? 's' : ''}})
    </button>
</mat-dialog-actions>